import { api } from "#app/http/api";
import { ClientDto } from "#modules/clients/infra/Client.dto";

type ContactDto = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
};

type AddressDto = {
  id: string;
  street: string;
  city: string;
  zipCode: string;
  country?: string;
};

export interface ClientWithContactsAndAddressDto extends ClientDto {
  contacts: ContactDto[];
  addresses: AddressDto[];
}
export const fetchClients = async (): Promise<ClientWithContactsAndAddressDto[]> => {
  const response = await api.clients.findAll.query();

  if (response.status === 200) {
    return response.body;
  }

  return [];
};
